import { render, staticRenderFns } from "./ProjectManagers.vue?vue&type=template&id=12dabe74&"
import script from "./ProjectManagers.vue?vue&type=script&lang=js&"
export * from "./ProjectManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports